A date-time string compliant with RFC 3339.
